import { Tooltip } from ".."
import Label from "../Label"

const NonStandardItemDetail = (props: any) => {
    const { item, isApproval=false } = props
    return (
        <>
            <div className='make'>
                <Label data-attribute="index_Default_Label_3">Make</Label>
                <Tooltip content={item?.make || '-'} data-attribute="index_Default_Tooltip_5">
                    <div>{item?.make || '-'}</div>
                </Tooltip>
            </div>
            <div className="model">
                <Label data-attribute="index_Default_Label_2_2">Model#</Label>
                <Tooltip content={item?.model || '-'} data-attribute="index_Default_Tooltip_2_3">
                    <div>{item?.model || '-'}</div>
                </Tooltip>
            </div>
            <div className='year'>
                <Label data-attribute="index_Default_Label_3_2">Year</Label>
                <Tooltip content={item?.year || '-'} data-attribute="index_Default_Tooltip_3_2">
                    <div>{item?.year || '-'}</div>
                </Tooltip>
            </div>
            <div className='used'>
                <Label data-attribute="index_Default_Label_4">Used</Label>
                <Tooltip content={item.isUsed.toString() == 'true' ? 'Yes' : 'No'} data-attribute="index_Default_Tooltip_4_2">
                    <div> {item.isUsed.toString() == 'true' ? 'Yes' : 'No'}</div>
                </Tooltip>
            </div>
            <div className='vendorDetails'>
                <Label data-attribute="index_Default_Label_5">Dealer Details</Label>
                <Tooltip content={item?.vendorDetail?.addressBookNumber + '-' + item?.vendorDetail?.vendorName + ', ' + item?.vendorDetail?.contact + ', ' + item?.vendorDetail?.address1 + ', ' + item?.vendorDetail?.address2 + '  ' + item?.vendorDetail?.address3 + '  ' + item?.vendorDetail?.city + ', ' + item?.vendorDetail?.state + ', ' + item?.vendorDetail?.zip + ' PH:' + item?.vendorDetail?.phone + ', Email: ' + item?.vendorDetail?.contactEmail} data-attribute="index_Default_Tooltip_5_2">
                    <div>{item?.vendorDetail?.addressBookNumber} - {item?.vendorDetail?.vendorName}</div>
                    <div>{item?.vendorDetail?.contact}</div>
                    <div>{item?.vendorDetail?.address1}, {item?.vendorDetail?.address2} {item?.vendorDetail?.address2 ? ',' : ''} {item?.vendorDetail?.address3} {item?.vendorDetail?.address3 ? ',' : ''} {item?.vendorDetail?.city}, {item?.vendorDetail?.state}, {item?.vendorDetail?.zip}</div>
                    <div>PH: {item?.vendorDetail?.phone}, Email: {item?.vendorDetail?.contactEmail}</div>
                </Tooltip>
            </div>
            <div className='used'>
                <Label data-attribute="index_Default_Label_6">Description</Label>
                <Tooltip content={item?.description ? item?.description : '-'} data-attribute="index_Default_Tooltip_6">
                    <div> {item?.description ? item?.description : '-'}</div>
                </Tooltip>
            </div>
            {isApproval ?
                <div className='frs-order non-standard '>
                    <Label data-attribute="index_Default_Label_7">FRS Order #</Label>
                    <Tooltip content={item?.frsOrderNumber + ""} data-attribute="index_Default_Tooltip_7">
                        <div>{item?.frsOrderNumber || '-'}</div>
                    </Tooltip>
                </div>
                : null}
        </>
    )
}

export default NonStandardItemDetail